export const SET_POLICY_LIST = "flight/SET_POLICY_LIST";
export const UPDATE_POLICY_LIST = "flight/UPDATE_POLICY_LIST";
export const COPY_POLICY_SUCCESS = "flight/COPY_POLICY_SUCCESS"
export const DELETE_POLICY_SUCCESS = "flight/DELETE_POLICY_SUCCESS"
export const CHANGE_STATUS_POLICY_SUCCESS = "flight/CHANGE_STATUS_POLICY_SUCCESS"
export const ACTION_POLICY_SUCCESS = "flight/ACTION_POLICY_SUCCESS"
export const FETCH_RULE_STATUS_CHANGE = "flight/FETCH_RULE_STATUS_CHANGE"
export const RESET_POLICY_LIST = "flight/RESET_POLICY_LIST"
export const SET_LOCATION_DATA = "flight/SET_LOCATION_DATA"